import { QueryClient } from "@tanstack/react-query";
import { createBrowserHistory, createRouter } from "@tanstack/react-router";

import { ToastPayload } from "./components/router/toast";
import { routeTree } from "./routeTree.gen";
import { trackNavigationHistory } from "./utils/navigation-history";
import { queryClient } from "./utils/query-client";

export interface RouterContext {
    queryClient: QueryClient;
    toast?: ToastPayload;
}

export const router = createRouter({
    routeTree,
    context: {
        queryClient: queryClient,
        toast: undefined,
    },
    defaultPreload: "intent",
    scrollRestoration: true,
    history: createBrowserHistory(),
});

trackNavigationHistory(router.history);
